import React, { useEffect, useState } from "react";

import Logo from "./logo";
import "./styles/scrollLogoRing.css";

// A fixed corner badge that appears once the reader scrolls past the hero.
// The logo sits inside a ring that fills with scroll progress, so the mark
// doubles as a "how far through the page am I" indicator. Parked in the
// top-left corner, out of the centered reading column, so it never overlays
// the text. Clicking it scrolls back to the top.
const RADIUS = 27;
const CIRC = 2 * Math.PI * RADIUS;

const ScrollLogoRing = () => {
	const [progress, setProgress] = useState(0);
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		const onScroll = () => {
			const top =
				window.scrollY || document.documentElement.scrollTop || 0;
			const max =
				document.documentElement.scrollHeight - window.innerHeight;
			setProgress(max > 0 ? Math.min(1, top / max) : 0);
			const active = top > 320;
			setVisible(active);
			// Signal the rest of the page (used to hide per-page static logos
			// once the ring takes over as the persistent mark).
			document.body.classList.toggle("ring-active", active);
		};
		window.addEventListener("scroll", onScroll, { passive: true });
		onScroll();
		return () => {
			window.removeEventListener("scroll", onScroll);
			document.body.classList.remove("ring-active");
		};
	}, []);

	return (
		<div
			className={`scroll-logo-ring${visible ? " visible" : ""}`}
			onClick={() =>
				window.scrollTo({ top: 0, behavior: "smooth" })
			}
			aria-label="Back to top"
			role="button"
		>
			<svg width="66" height="66" className="scroll-logo-ring-svg">
				<circle
					className="ring-track"
					cx="33"
					cy="33"
					r={RADIUS}
				/>
				<circle
					className="ring-progress"
					cx="33"
					cy="33"
					r={RADIUS}
					strokeDasharray={CIRC}
					strokeDashoffset={CIRC * (1 - progress)}
				/>
			</svg>
			<div className="scroll-logo-ring-mark">
				<Logo width={34} link={false} />
			</div>
		</div>
	);
};

export default ScrollLogoRing;
